<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('change_password') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onSave"><i class="fa fa-floppy-o"></i> {{$t('save')}}</button>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="form-group" :class="{ 'form-group-error': $v.model.PasswordHash.$error }">
                                <label class="label-control blue">{{$t('user_password')}}</label>
                                <input type="password" class="form-control form-control-sm" v-model="$v.model.PasswordHash.$model" />
                            </div>
                            <div class="form-group" :class="{ 'form-group-error': $v.model.Verify.$error }">
                                <label class="label-control blue">{{$t('user_confirm_password')}}</label>
                                <input type="password" class="form-control form-control-sm" v-model="$v.model.Verify.$model" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { required, sameAs, minLength } from 'vuelidate/lib/validators';
    export default {
        data(){
            return {
                model: {
                    PasswordHash: '',
                    Verify: ''
                }
            }
        },
        validations:{
            model: {
                PasswordHash: {
                    required,
                    minLength: minLength(6)
                },
                Verify: { 
                    sameAsPassword: sameAs('PasswordHash')
                }
            }
        },
        methods: {
            onSave(){
                this.$v.$touch();
                if(!this.$v.$invalid) {
                    let loading = this.$loading.show();
                    this.$api().post('account/change/password', this.model).then((res) => {
                        if(this.$isValid(res)){
                            this.$router.go(-1);
                        }
                    }).finally(() => { loading.hide(); });
                }
            }
        }
    }
</script>